export const PUSH_NOTIFICATION = 'ADD_NOTIFICATION';
export const POP_NOTIFICATION = 'CLEAR_NOTIFICATION';
